import { Tag } from 'antd';
import { type SelectProps } from 'antd';
import React from 'react';

type TagRender = SelectProps['tagRender'];

function getContrastColor(hex: string): string {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  // perceived luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.55 ? '#000000' : '#ffffff';
}

export const tagRender: TagRender = (props): React.ReactElement => {
  const { label, value, closable, onClose } = props;
  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const bg =
    typeof value === 'string' && value.startsWith('#') ? value : undefined;
  const textColor = bg ? getContrastColor(bg) : undefined;

  return (
    <Tag
      color={bg ? undefined : value}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{
        marginInlineEnd: 4,
        ...(bg && {
          background: bg,
          color: textColor,
          border: 'none',
          fontWeight: 600,
        }),
      }}
    >
      {label}
    </Tag>
  );
};
